import gql from 'graphql-tag';

const DEVICE_DETAILS = gql`
  query Query($deviceSerialNo: String!) {
    device(deviceSerialNo: $deviceSerialNo) {
      generatedDatetime
      customer
      revoked
      sensors
      deviceSerialNo
      IMEI
      deviceType
      creator
      broker
      dataFrequency
      decommissioned
      lastAuthCheckedTime
      ssl
      stage
      hardwareVersion
      OTACompatible
      isBillable
      billingApplicableFrom
      initialCreditsAttached
      version
      status
      simNumber
      arambhDevice
      deviceTypeName
      subType
      subTypeName
      networkProvider
      tags
      firmwareVersion
      OTAFirmwareVersion
      batch
      vendor
      sharedDevice
      stageTransitionHistory {
        stage
        date
        by
      }
      qcCycles {
        startDate
        endDate
      }
      device360 {
        category
        customerName
        customerId
        customerType
        plotId
        plotName
        isInfluentialCustomer
        crop {
          cropName
          cropIdentifier
          varietyIdentifier
          varietyName
        }
        soil {
          type
          identifier
        }
      }
      sensorData {
        battery {
          datetime
          value
        }
        lastSyncTime
        errorData
      }
      pauseData {
        pausedOn
        reason
      }
    }
  }
`;

export default DEVICE_DETAILS;
